// data.xxx の変更を検知&htmlのjsonを自動で更新する
function createDeepProxy(obj, onChange) {
  const handler = {
    get(target, key, receiver) {
      const value = Reflect.get(target, key, receiver);
      if (typeof value === 'object' && value !== null) {
        return new Proxy(value, handler); // ネストされたオブジェクトに再帰的にプロキシを適用
      }
      return value;
    },
    set(target, key, value, receiver) {
      const result = Reflect.set(target, key, value, receiver);
      onChange(); // 任意の変更でコールバック関数を実行
      return result;
    },
  };
  return new Proxy(obj, handler);
}

const files = import.meta.glob('./components/**/*.svelte', { eager: true });

const modules = {};
for (const key in files) {
  modules[key.replace(/(\.\/|\.svelte)/g, '').replace(/components\//g, '')] = files[key].default;
}

document.addEventListener('turbo:load', function () {
  // 以前の Svelte アプリを破棄してメモリリークを防ぐ
  if (window.svelteApps) {
    window.svelteApps.forEach((app) => {
      if (app && typeof app.destroy === 'function') {
        app.destroy();
      }
    });
    window.svelteApps = [];
  }
  window.svelteApps ||= [];

  // Svelte をマークしたすべての DOM コンポーネントを検索
  document.querySelectorAll('[data-svelte]').forEach((domComponent) => {
    const componentName = domComponent.dataset.svelte;
    const id = domComponent.dataset.id;
    const dataElement = document.getElementById(id);
    if (!dataElement) {
      console.error(
        `データ要素 #${id} がコンポーネント ${componentName} に対して見つかりませんでした。`,
      );
      return;
    }
    const initialData = JSON.parse(dataElement.textContent);

    // データ変更を検知して JSON を更新
    const reactiveData = createDeepProxy(initialData, () => {
      dataElement.textContent = JSON.stringify(initialData);
    });

    // 新しい Svelte コンポーネントインスタンスを作成
    const svelteComponent = new modules[componentName]({
      target: domComponent,
      props: { data: reactiveData },
    });

    // 次の Turbo ロード時に削除するためにインスタンスを保存
    window.svelteApps.push(svelteComponent);
  });
});
